import translate from "./Translate"

const displayPriceVavue = ( price ) => {

    let value 

    // switch ( price ) {
    //     case 0:
    //     case 1:
    //     case 2:    
    //         value = translate('Low')
    //         break
    //     case 3:
    //     case 4:
    //         value = translate('Medium')
    //         break   
    //     case 5:
    //         value = translate('High')
    //         break
    //     default:
    //         value = price
    //         break
    // }
    switch ( price ) {
        case 0:
        case 1:
            value = translate('Cheap')
            break
        case 2:    
            value = translate('Affordable')
            break
        case 3:
            value = translate('Moderate')
            break
        case 4:
            value = translate('Pricey')
            break   
        case 5:
            value = translate('Premium')
            break
        default:
            value = price
            break
    }

    return value

} 

export default displayPriceVavue
